import React from 'react'
import { PictureOutlined } from "@ant-design/icons";

import OppBriefSection from "./OppBriefSection";
import ExperienceGroup from "../../../components/ExperienceGroup";
import SkillFormButton from "../../talent-application/components/SkillFormButton";
import { AuthContext } from "../../../providers/AuthProvider";

export default class OppBriefRoleSkillsSection extends OppBriefSection {

    static sectionTitle = 'Role Overview';

    static TranslationKey = 'start_project.contract_deliverables';

    static CompletedField = 'accepted_role_skills_at';


    //contextType of the component is AuthContext. i.e this.context.auth = TB auth user
    static contextType = AuthContext;
    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        }
    }

    render() {
        let { opportunity } = this.props;
        let { project_position, project } = opportunity;

        let auth = this.context.auth,
            authSkills = auth?.skillsById(),
            authIndustries = auth?.experiencedIndustriesById();


        return (
            <div className="project-brief-section">
                <div className="deliverable-category-container role-skill-overview">
                    <p className={`deliverable-cat-header ${opportunity.hasUnseenUpdateToProjectPositionTitle() ? 'opp-unseen-update' : ''}`}>
                        {project_position.title}

                    </p>

                    <hr />
                    <div className="deliverable-panel">
                        <div className="deliverable-panel">
                            <p className={`deliverable-title ${opportunity.hasUnseenUpdateToProjectPositionDiscipline() || opportunity.hasUnseenUpdateToProjectPositionDisciplineDescription() ? 'opp-unseen-update' : ''}`}>
                                Role Description

                            </p>
                            <div className="deliverable-details-panel">
                                <div className="deliverable-section">
                                    <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionDescription() ? 'opp-unseen-update' : ''}`}>
                                        Description

                                    </p>
                                    {TB.stripHtml(project_position.description)?.length > 0 ? <div className="rich-text-display mb-3">
                                        <span dangerouslySetInnerHTML={{ __html: project_position.description }} />
                                    </div> : (
                                        <p className="deliverable-section-description">
                                            Not Provided
                                        </p>
                                    )}
                                </div>
                                <div className="deliverable-section">
                                    <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionIsContractToHire() ? 'opp-unseen-update' : ''}`}>
                                        Contract to Hire Interest?

                                    </p>
                                    <p className="deliverable-section-description">
                                        {project_position.is_contract_to_hire ? 'Yes' : 'No'}
                                    </p>
                                </div>
                                {TB.isDefined(project_position.description_path) && (
                                    <div className="deliverable-section">
                                        <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionDescriptionPath() ? 'opp-unseen-update' : ''}`}>
                                            Supporting Document
                                        </p>

                                        <p className="deliverable-section-description deliverable-section-document">
                                            <i className="far fa-file-alt" />
                                            <a target="_blank"
                                                href={project_position.description_path}
                                                className="btn btn-link">
                                                View/Download
                                            </a>
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {project_position.discipline && (
                            <div className="deliverable-panel">
                                <p className={`deliverable-title ${opportunity.hasUnseenUpdateToProjectPositionDiscipline() || opportunity.hasUnseenUpdateToProjectPositionDisciplineDescription() ? 'opp-unseen-update' : ''}`}>
                                    {laravel.platform_name} Role
                                </p>
                                {project_position.discipline && (
                                    <div className="flex deliverable-details-panel">
                                        <div className="deliverable-section" style={{ flexBasis: 'unset', flex: 1 }}>
                                            <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionDiscipline() ? 'opp-unseen-update' : ''}`}>
                                                Title

                                            </p>
                                            <p className="deliverable-section-description">
                                                {project_position.discipline.name}
                                            </p>
                                        </div>
                                        <div className="deliverable-section" style={{ flexBasis: 'unset', flex: 2 }}>
                                            <p className={`deliverable-section-title ${opportunity.hasUnseenUpdateToProjectPositionDisciplineDescription() ? 'opp-unseen-update' : ''}`}>
                                                Description

                                            </p>
                                            <p className="deliverable-section-description">
                                                {project_position.discipline.description}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="deliverable-panel pb-4">
                            <p className={`deliverable-title mb-0 ${opportunity.hasUnseenUpdateToProjectPositionMinScore() ? 'opp-unseen-update' : ''}`}>
                                Experience Level
                            </p>

                            <div className="deliverable-details-panel">
                                <p className="experience-selected-info pb-2">
                                    Minimum level of experience:&nbsp;
                                    <b>{`${opportunity.experienceLevel()} (${opportunity.experienceLabel()})`}</b>
                                </p>

                                <ExperienceGroup
                                    minSelected={project_position.min_score}
                                    wants_intermediate_experience={project_position.wants_intermediate_experience}
                                    wants_junior_experience={project_position.wants_junior_experience}
                                    wants_senior_experience={project_position.wants_senior_experience}
                                />

                            </div>
                        </div>

                        {!!project_position.brands?.length && (
                            <div className="deliverable-panel pb-4">
                                <p className={`deliverable-title ${opportunity.hasUnseenUpdateToProjectPositionMinScore() ? 'opp-unseen-update' : ''}`}>
                                    {/* Associated Brands */}
                                    Desired Brand or Company Experience
                                </p>

                                <div className="deliverable-details-panel">
                                    <div className="flex flex-row flex-wrap mt-2 gap-x-3 gap-y-5 mb-3">
                                        {TB.map(project_position?.brands || [], (brand, index) => {
                                            return (
                                                <div key={`brand-${index}-${brand.id || brand.brandId}`}
                                                    className="bg-gray-50 inline-flex flex-row justify-start items-center relative gap-3 py-3 pl-4 pr-8 min-w-[200px] border h-28">

                                                    <div className="flex items-center justify-start">
                                                        {(brand.logo || brand.icon) ?
                                                            <img className="h-full max-h-20 w-full max-w-32 object-contain" src={brand.logo || brand.icon}
                                                                alt={brand.name} /> : (
                                                                <PictureOutlined className="w-full max-w-full" style={{ fontSize: 56 }} />
                                                            )}
                                                    </div>

                                                    <div className="flex flex-col flex-grow gap-1">
                                                        <p className="text-base">{brand.name || brand.domain}</p>
                                                        {brand.name && brand.domain && (
                                                            <p className="text-xs text-info whitespace-nowrap">
                                                                {brand.domain}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        )}

                        {project_position.skills?.length > 0 && (
                            <div className="deliverable-panel">
                                <p className={`deliverable-title ${opportunity.hasUnseenUpdateToProjectPositionSkills() ? 'opp-unseen-update' : ''}`}>
                                    Required Skills

                                </p>
                                <div className="deliverable-details-panel">
                                    {!opportunity.is_agency_opp && (
                                        <p className="detail-note"><i>
                                            <span className="indicator indicator-success" />
                                            Indicates a match from your public profile</i></p>
                                    )}
                                    <div className="deliverable-section talent-role-form">
                                        <div className="field-section">
                                            <div className="field-element">
                                                <div className="form-group">
                                                    <div
                                                        className="discipline-skills-container skill-importance-container">
                                                        {TB.orderBy(project_position.skills, skill => authSkills.includes(skill.id) ? 1 : 0, 'desc')
                                                            .map((skill) => (
                                                                <SkillFormButton
                                                                    key={`${skill.name}`}
                                                                    className={authSkills.includes(skill.id) ? 'has-skill' : ''}
                                                                    valuePropName={'importance'}
                                                                    disabled={true}
                                                                    scoringOptions={laravel.importance_levels}
                                                                    skill={skill}
                                                                    selected={authSkills.includes(skill.id)}
                                                                    onChange={(model) => {
                                                                        // console.log(model)
                                                                    }}
                                                                />
                                                            )
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {project_position.industries?.length > 0 && (
                            <div className="deliverable-panel">
                                <p className={`deliverable-title ${opportunity.hasUnseenUpdateToProjectPositionIndustries() ? 'opp-unseen-update' : ''}`}>
                                    Preferred Industry Experience
                                </p>
                                <div className="deliverable-details-panel">
                                    {!opportunity.is_agency_opp && (
                                        <p className="detail-note"><i>
                                            <span className="indicator indicator-success" />
                                            Indicates a match from your public profile</i></p>
                                    )}
                                    <div className="deliverable-section talent-role-form">
                                        <div className="field-section">
                                            <div className="field-element">
                                                <div className="form-group">
                                                    <div
                                                        className="discipline-skills-container skill-importance-container">
                                                        {TB.orderBy(project_position.industries, industry => authIndustries.includes(industry.id) ? 1 : 0, 'desc')
                                                            .map((industry) => (
                                                                <SkillFormButton
                                                                    key={`${industry.name}`}
                                                                    className={authIndustries.includes(industry.id) ? 'has-skill' : ''}
                                                                    valuePropName={'importance'}
                                                                    disabled={true}
                                                                    scoringOptions={laravel.importance_levels}
                                                                    skill={industry}
                                                                    selected={authIndustries.includes(industry.id)}
                                                                    onChange={(model) => {
                                                                        // console.log(model)
                                                                    }}
                                                                />
                                                            )
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}